import React, { Fragment, useState } from "react";
import { Button, Layout, Modal } from "antd";
import Header from "../Header";
import Content from "../Content";
import Footer from "../Footer";

const MainLayout = ({ history, ContentBody }) => {
  const [isPolicyModal, setIsPolicyModal] = useState(false);

  const closePolicyModal = () => setIsPolicyModal(false);

  return (
    <Fragment>
      <Layout className="layout-wrapper">
        <Header history={history} />
        <Content ContentBody={ContentBody} />
        <Footer openPolicyModal={() => setIsPolicyModal(true)} />
      </Layout>

      <Modal
        visible={isPolicyModal}
        onCancel={closePolicyModal}
        centered
        title="이용약관"
        footer={
          <Button type="primary" size="large" className="basic-button dark-green" onClick={closePolicyModal}>
            확인
          </Button>
        }
        maskClosable={false}
      >
        <div style={{ height: "500px", overflow: "scroll", whiteSpace: "pre-wrap" }}>
          {`※ 아임게이트 이용약관 동의 (필수)
제1조 개인정보의 처리 목적
회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
수집한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.
1) 예약 정보 안내 서비스
- 이용자에게 숙박 예약정보를 안내하기 위한 목적으로 개인정보를 수집합니다.
2) 비대면 체크인 서비스
- 이용자가 비대면 체크인 서비스 이용 시, 고객정보를 확인하기 위한 목적으로 개인정보를 수집합니다.
3) 마케팅 및 광고, 이벤트 정보 제공
- 이용자에게 숙박 서비스 소개 및 판매, 이벤트, 행사 안내(SMS)등의 목적으로 개인정보를 수집합니다. 
4) 민원사무 처리
- 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 수집합니다.

제2조 이용자의 권리 및 의무
이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
1) 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
- 개인정보 열람요구
- 오류 등이 있을 경우 정정 요구
- 삭제요구
- 처리정지 요구
2) 권리 행사는 회사에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라, 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
3) 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
4) 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출해야 합니다.
- 공지일자: 2021.02.25 
- 적용일자: 2021.02.25

※ 개인정보 수집 및 이용동의 (필수)
제1조 개인정보의 수집 및 이용
회사는 이용자의 동의를 기반으로 개인정보를 수집 및 이용, 제공합니다.
1) 개인정보 수집 항목
- 이름, 휴대전화번호
2) 개인정보 수집 방법
- 숙박 예약 시 이용자의 동의를 기반으로 개인정보 수집
3) 보유 근거
- 예약정보 안내 서비스
- 비대면 체크인 서비스
- 마케팅 및 광고, 이벤트 정보 제공 - 민원사무 처리
4) 보유 기간
- 개인정보처리의 동의를 철회하거나 1년 동안 이용하지 아니하는 경우, 개인정보보호를 위해 지체 없이 파기합니다. 다만, 관계법령에 의해 보관해야 하는 정보는 법령이 정한 기간 동안 보관합니다.

제2조 개인정보의 제3자 제공에 관한 사항
회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
다만, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
1) 이용자들이 사전에 동의한 경우
2) 법령의 규정 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 

제3조 개인정보의 파기
회사는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체 없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
1) 파기절차
이용자가 입력한 정보는 목적 달성 후 별도의DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아닐 때를 제외하고 다른 목적으로 이용되지 않습니다.
2) 파기기한
이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터5일 이내에 그 개인정보를 파기합니다.
3) 파기방법
전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용 합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

제4조 개인정보의 안전성 확보 조치
회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
1) 정기적인 자체 감사 실시
개인정보 취급 관련 안정성 확보를 위해 정기적(분기1회)으로 자체 감사를 실시하고 있습니다.
2) 개인정보 취급 직원의 최소화 및 교육
개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.
3) 내부관리계획의 수립 및 시행
개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
4) 해킹 등에 대비한 기술적 대책
회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
5) 개인정보의 암호화
이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
6) 접속기록의 보관 및 위변조 방지
개인정보처리시스템에 접속한 기록을 최소6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.
7) 개인정보에 대한 접근 제한
개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
8) 문서보안을 위한 잠금 장치 사용
개인정보가 포함된 서류, 보조저장매체 등을 잠금 장치가 있는 안전한 장소에 보관하고 있습니다.
9) 비인가자에 대한 출입 통제
개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.

제5조 개인정보 열람청구
정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
1) 개인정보 열람청구 접수·처리 부서 
- 부서명: (주)아임게이트 고객센터 
- 연락처: contact@imgate.co.kr

제6조 개인정보 처리방침 변경
개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 비대면 체크인 웹의 공지사항(또는 개별공지)을 통하여 고지할 것입니다.
- 본 방침은 2021년 02월 25일부터 시행됩니다.

※ 이벤트 및 마케팅 활용 동의 (선택)
아임게이트에서 제공하는 이벤트/혜택 등 다양한 정보를 휴대전화로 받아 보실 수 있습니다.`}
        </div>
      </Modal>
    </Fragment>
  );
};

export default MainLayout;
